<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Export Planogram Excel</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-3">
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">Export Options</h5>
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
          <label for="limitDepthByDOS">Limit Depth by DOS</label>
        </div>
        <div class="col d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="limitDepthByDOS"
              [(ngModel)]="limitDepthByDOS"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="confirm()">Export</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>